// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__1SpPr","arrowIcon":"DateRangeController_arrowIcon__1m0SE"};